export default __webpack_public_path__ + "static/media/thumbnail.e294f7ba.png";